module.exports = __webpack_public_path__ + "static/media/app_store.1cfd5dba.svg";